const stickyNavigation = {
    init() {

        const header = document.getElementById('header');
        const header_not_hp = document.getElementById('stickyNavTrigger');
        const stickyNavigation = document.querySelector('.sticky-navigation');


        // console.log(header_not_hp);

        if(header) {
            var currentHeader = header.offsetHeight;
        }
        
        if(header_not_hp) {
            var currentHeader = header_not_hp.offsetHeight;
            // console.log(currentHeader);
        }

        document.addEventListener("DOMContentLoaded", function() {
            activeStickyNav();
        });

        document.addEventListener('scroll', () => {
            activeStickyNav();
        });

        function activeStickyNav() {
            var currentPosition = window.scrollY;
            var halfHeaderHeight = currentHeader / 2;

            if(currentPosition >= halfHeaderHeight) {
                stickyNavigation.classList.add('active');
            }
            else {
                stickyNavigation.classList.remove('active');
            }
        }

    }
}

export default stickyNavigation;